export default {
  changedFoldersSortOption: 'Changed folders sort option',
  changedSharedFoldersSortOption: 'Change shared folders sort option',
  viewedPublishedFolder: 'Viewed published folder',
  viewedPublishedFoldersSection: 'Viewed published folders section',
  viewedSharedFolder: 'Viewed shared folder',
  viewedSharedFoldersSection: 'Viewed shared folders section',
}
